import { Button } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import React from 'react';

const DeleteModal = ({
  showModal = false,
  setShowModal,
  title,
  updateTenant,
  updateUserStatus,
  mutationId,
  setMutationId,
  isDisabled,
  fetchOrganizationData,
  fetchUserData,
  name,
  subtitle,
  id
}) => {
  const handleOk = () => {
    if (updateTenant) {
      updateTenant({
        variables: {
          id: mutationId,
          data: { isDisabled: !isDisabled }
        }
      }).then(() => {
        fetchOrganizationData();
      });
    } else {
      updateUserStatus({
        variables: {
          data: { userId: mutationId, tenantId: id }
        }
      }).then(() => {
        fetchUserData();
      });
    }
    setShowModal(false);
  };

  const handleCancel = () => {
    setMutationId('');
    setShowModal(false);
  };
  return (
    <div>
      <Modal
        centered
        closable={false}
        footer={null}
        title={`${title} ${subtitle}`}
        visible={showModal}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>
          {title === 'Deactivate'
            ? `Are you sure you want to ${title} ${name} and remove from all projects?`
            : `Are you sure you want to ${title} ${name}?`}
        </p>
        <div className="form-buttons">
          <Button
            shape="round"
            className="cancel-button"
            onClick={handleCancel}
          >
            No, Cancel
          </Button>
          <Button shape="round" className="save-button" onClick={handleOk}>
            Yes, {title}
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default DeleteModal;
